import { 
  CompanyDetails, 
  RepresentativesDetails, 
} from './components';

export const tabs = () => {
  return [
    {
      label: `1.1 Βασικά Στοιχεία Επιχείρησης`,
      id: 0,
      Component: CompanyDetails,
      disabled: false,
    },
    {
      label: `1.2 Στοιχεία Ταυτότητας Εκπροσώπου`,
      id: 1,
      Component: RepresentativesDetails,
      disabled: false,
    },
  ].filter(item => item);
};
